import { Divider } from '@sola/ark-core/atoms/divider/divider.js';
import { Alert } from '@sola/ark-core/molecules/alert/alert.js';
import { GraphQLCommitment } from '@sola/schema/dotcom/supporters/schema.generated.js';

import { CommitmentCardPayment } from '../commitment-card-payment/commitment-card-payment';

export interface MakeAPaymentSectionProps {
  title: string;
  description: string;
  commitments: GraphQLCommitment[];
  alertMessage?: string;
}

export const MakeAPaymentSection: React.FC<MakeAPaymentSectionProps> = ({
  title,
  description,
  commitments,
  alertMessage,
}) => {
  if (commitments.length === 0) {
    return null;
  }

  return (
    <>
      <div className="flex flex-col gap-snug-lg">
        <span className="heading-xs">{title}</span>
        <span className="body-sm body-neutral-mild">{description}</span>
      </div>

      {alertMessage && <Alert message={alertMessage} />}

      {commitments.map((commitment) => {
        return (
          <CommitmentCardPayment
            key={commitment.internalId}
            commitment={commitment}
          />
        );
      })}

      <Divider purpose="neutral" />
    </>
  );
};
